
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services'
import DeleteNewsTable, { ChangeOption } from './components/deleteNewsTable.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { NewsService } from '@/services/index'

enum STATUS {
    ALL = 'ALL',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED'
}

@Component({
    name: 'DeleteNewsApply',
    components: {
        DeleteNewsTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 40
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private status = STATUS.ALL
    private statusList = [
        { label: '全部', value: STATUS.ALL },
        { label: '审核中', value: STATUS.PENDING },
        { label: '审核通过', value: STATUS.APPROVED },
        { label: '审核不通过', value: STATUS.REJECTED }
    ]
    private applyList = []

    private mounted() {
        this.getApplyList()
    }

    private async getApplyList() {
        const params = {
            status: this.status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await UserService.getDeleteNewApplyList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.applyList = result.data.list
        }
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getApplyList)
    }

    private async onStatusChange({ status, target }: ChangeOption) {
        const params = { status, id: target.id }
        const result = await UserService.putDeleteNewApply(params)
        if (result.status === 200) {
            target.status = status
            this.$message({
                type: 'success',
                message: '审批状态修改成功',
                showClose: true
            })
            this.updateNewStatus(target.news.id, status)
            await this.getApplyList()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '审批状态修改失败',
            showClose: true
        })
        
    }

    private async updateNewStatus(news_id: number, status: string){
        let params : { id: number, is_deleted: boolean }
        if (status === STATUS.APPROVED) {
            params = { id: news_id, is_deleted: true }
        } else {
            params = { id: news_id, is_deleted: false }
        }
        await NewsService.updateNews(params)
    }

    private onStatusSelect(status: STATUS) {
        this.status = status
        this.getApplyList()
    }
}
